interface VonqChannelOption {
  id: string
  name: string
}

interface VonqChannelRawOption {
  key: string
  label: string
  sort: string
}

const normalizeRawData = (data: VonqChannelRawOption[]): VonqChannelOption[] => {
  return data
    .sort((a: VonqChannelRawOption, b: VonqChannelRawOption) => +a.sort - +b.sort)
    .map((option: VonqChannelRawOption) => ({ id: option.key, name: option.label }))
}

export const CategoriesOptions: VonqChannelOption[] = normalizeRawData([
  {
    key: 'acct',
    label: 'Accounting / Auditing',
    sort: '10',
  },
  {
    key: 'adm',
    label: 'Administrative',
    sort: '20',
  },
  {
    key: 'advr',
    label: 'Advertising',
    sort: '30',
  },
  {
    key: 'anls',
    label: 'Analyst',
    sort: '40',
  },
  {
    key: 'art',
    label: 'Art / Creative',
    sort: '50',
  },
  {
    key: 'bd',
    label: 'Business Development',
    sort: '60',
  },
  {
    key: 'cnsl',
    label: 'Consulting',
    sort: '70',
  },
  {
    key: 'cust',
    label: 'Customer Service',
    sort: '80',
  },
  {
    key: 'dist',
    label: 'Distribution',
    sort: '90',
  },
  {
    key: 'dsgn',
    label: 'Design',
    sort: '100',
  },
  {
    key: 'edu',
    label: 'Education',
    sort: '110',
  },
  {
    key: 'eng',
    label: 'Engineering',
    sort: '120',
  },
  {
    key: 'fin',
    label: 'Finance',
    sort: '130',
  },
  {
    key: 'genb',
    label: 'General Business',
    sort: '140',
  },
  {
    key: 'hcpr',
    label: 'HealthCare Provider',
    sort: '150',
  },
  {
    key: 'hr',
    label: 'Human Resources',
    sort: '160',
  },
  {
    key: 'it',
    label: 'Information Technology',
    sort: '170',
  },
  {
    key: 'lgl',
    label: 'Legal',
    sort: '180',
  },
  {
    key: 'mgmt',
    label: 'Management',
    sort: '190',
  },
  {
    key: 'mnfc',
    label: 'Manufacturing',
    sort: '200',
  },
  {
    key: 'mrkt',
    label: 'Marketing',
    sort: '210',
  },
  {
    key: 'othr',
    label: 'Other',
    sort: '220',
  },
  {
    key: 'pr',
    label: 'Public Relations',
    sort: '230',
  },
  {
    key: 'prch',
    label: 'Purchasing',
    sort: '240',
  },
  {
    key: 'prdm',
    label: 'Product Management',
    sort: '250',
  },
  {
    key: 'prjm',
    label: 'Project Management',
    sort: '260',
  },
  {
    key: 'prod',
    label: 'Production',
    sort: '270',
  },
  {
    key: 'qa',
    label: 'QualityAssurance',
    sort: '280',
  },
  {
    key: 'rsch',
    label: 'Research',
    sort: '290',
  },
  {
    key: 'sale',
    label: 'Sales',
    sort: '300',
  },
  {
    key: 'sci',
    label: 'Science',
    sort: '310',
  },
  {
    key: 'stra',
    label: 'Strategy / Planning',
    sort: '320',
  },
  {
    key: 'supl',
    label: 'Supply Chain',
    sort: '330',
  },
  {
    key: 'trng',
    label: 'Training',
    sort: '340',
  },
  {
    key: 'wrt',
    label: 'Writing / Editing',
    sort: '350',
  },
])

export const IndustriesOptions: VonqChannelOption[] = normalizeRawData([
  {
    key: '47',
    label: 'Accounting',
    sort: '10',
  },
  {
    key: '94',
    label: 'Airlines/Aviation',
    sort: '20',
  },
  {
    key: '120',
    label: 'Alternative Dispute Resolution',
    sort: '30',
  },
  {
    key: '125',
    label: 'Alternative Medicine',
    sort: '40',
  },
  {
    key: '127',
    label: 'Animation',
    sort: '50',
  },
  {
    key: '19',
    label: 'Apparel & Fashion',
    sort: '60',
  },
  {
    key: '50',
    label: 'Architecture & Planning',
    sort: '70',
  },
  {
    key: '111',
    label: 'Arts and Crafts',
    sort: '80',
  },
  {
    key: '53',
    label: 'Automotive',
    sort: '90',
  },
  {
    key: '52',
    label: 'Aviation & Aerospace',
    sort: '100',
  },
  {
    key: '41',
    label: 'Banking',
    sort: '110',
  },
  {
    key: '12',
    label: 'Biotechnology',
    sort: '120',
  },
  {
    key: '36',
    label: 'Broadcast Media',
    sort: '130',
  },
  {
    key: '49',
    label: 'Building Materials',
    sort: '140',
  },
  {
    key: '138',
    label: 'Business Supplies and Equipment',
    sort: '150',
  },
  {
    key: '129',
    label: 'Capital Markets',
    sort: '160',
  },
  {
    key: '54',
    label: 'Chemicals',
    sort: '170',
  },
  {
    key: '90',
    label: 'Civic & Social Organization',
    sort: '180',
  },
  {
    key: '51',
    label: 'Civil Engineering',
    sort: '190',
  },
  {
    key: '128',
    label: 'Commercial Real Estate',
    sort: '200',
  },
  {
    key: '118',
    label: 'Computer & Network Security',
    sort: '210',
  },
  {
    key: '109',
    label: 'Computer Games',
    sort: '220',
  },
  {
    key: '3',
    label: 'Computer Hardware',
    sort: '230',
  },
  {
    key: '5',
    label: 'Computer Networking',
    sort: '240',
  },
  {
    key: '4',
    label: 'Computer Software',
    sort: '250',
  },
  {
    key: '48',
    label: 'Construction',
    sort: '260',
  },
  {
    key: '24',
    label: 'Consumer Electronics',
    sort: '270',
  },
  {
    key: '25',
    label: 'Consumer Goods',
    sort: '280',
  },
  {
    key: '91',
    label: 'Consumer Services',
    sort: '290',
  },
  {
    key: '18',
    label: 'Cosmetics',
    sort: '300',
  },
  {
    key: '65',
    label: 'Dairy',
    sort: '310',
  },
  {
    key: '1',
    label: 'Defense & Space',
    sort: '320',
  },
  {
    key: '99',
    label: 'Design',
    sort: '330',
  },
  {
    key: '69',
    label: 'Education Management',
    sort: '340',
  },
  {
    key: '132',
    label: 'E-Learning',
    sort: '350',
  },
  {
    key: '112',
    label: 'Electrical/Electronic Manufacturing',
    sort: '360',
  },
  {
    key: '28',
    label: 'Entertainment',
    sort: '370',
  },
  {
    key: '86',
    label: 'Environmental Services',
    sort: '380',
  },
  {
    key: '110',
    label: 'Events Services',
    sort: '390',
  },
  {
    key: '76',
    label: 'Executive Office',
    sort: '400',
  },
  {
    key: '122',
    label: 'Facilities Services',
    sort: '410',
  },
  {
    key: '63',
    label: 'Farming',
    sort: '420',
  },
  {
    key: '43',
    label: 'Financial Services',
    sort: '430',
  },
  {
    key: '38',
    label: 'Fine Art',
    sort: '440',
  },
  {
    key: '66',
    label: 'Fishery',
    sort: '450',
  },
  {
    key: '34',
    label: 'Food & Beverages',
    sort: '460',
  },
  {
    key: '23',
    label: 'Food Production',
    sort: '470',
  },
  {
    key: '101',
    label: 'Fund-Raising',
    sort: '480',
  },
  {
    key: '26',
    label: 'Furniture',
    sort: '490',
  },
  {
    key: '29',
    label: 'Gambling & Casinos',
    sort: '500',
  },
  {
    key: '145',
    label: 'Glass, Ceramics & Concrete',
    sort: '510',
  },
  {
    key: '75',
    label: 'Government Administration',
    sort: '520',
  },
  {
    key: '148',
    label: 'Government Relations',
    sort: '530',
  },
  {
    key: '140',
    label: 'Graphic Design',
    sort: '540',
  },
  {
    key: '124',
    label: 'Health, Wellness and Fitness',
    sort: '550',
  },
  {
    key: '68',
    label: 'Higher Education',
    sort: '560',
  },
  {
    key: '14',
    label: 'Hospital & Health Care',
    sort: '570',
  },
  {
    key: '31',
    label: 'Hospitality',
    sort: '580',
  },
  {
    key: '137',
    label: 'Human Resources',
    sort: '590',
  },
  {
    key: '134',
    label: 'Import and Export',
    sort: '600',
  },
  {
    key: '88',
    label: 'Individual & Family Services',
    sort: '610',
  },
  {
    key: '147',
    label: 'Industrial Automation',
    sort: '620',
  },
  {
    key: '84',
    label: 'Information Services',
    sort: '630',
  },
  {
    key: '96',
    label: 'Information Technology and Services',
    sort: '640',
  },
  {
    key: '42',
    label: 'Insurance',
    sort: '650',
  },
  {
    key: '74',
    label: 'International Affairs',
    sort: '660',
  },
  {
    key: '141',
    label: 'International Trade and Development',
    sort: '670',
  },
  {
    key: '6',
    label: 'Internet',
    sort: '680',
  },
  {
    key: '45',
    label: 'Investment Banking',
    sort: '690',
  },
  {
    key: '46',
    label: 'Investment Management',
    sort: '700',
  },
  {
    key: '73',
    label: 'Judiciary',
    sort: '710',
  },
  {
    key: '77',
    label: 'Law Enforcement',
    sort: '720',
  },
  {
    key: '9',
    label: 'Law Practice',
    sort: '730',
  },
  {
    key: '10',
    label: 'Legal Services',
    sort: '740',
  },
  {
    key: '72',
    label: 'Legislative Office',
    sort: '750',
  },
  {
    key: '30',
    label: 'Leisure, Travel & Tourism',
    sort: '760',
  },
  {
    key: '85',
    label: 'Libraries',
    sort: '770',
  },
  {
    key: '116',
    label: 'Logistics and Supply Chain',
    sort: '780',
  },
  {
    key: '143',
    label: 'Luxury Goods & Jewelry',
    sort: '790',
  },
  {
    key: '55',
    label: 'Machinery',
    sort: '800',
  },
  {
    key: '11',
    label: 'Management Consulting',
    sort: '810',
  },
  {
    key: '95',
    label: 'Maritime',
    sort: '820',
  },
  {
    key: '97',
    label: 'Market Research',
    sort: '830',
  },
  {
    key: '80',
    label: 'Marketing and Advertising',
    sort: '840',
  },
  {
    key: '135',
    label: 'Mechanical or Industrial Engineering',
    sort: '850',
  },
  {
    key: '126',
    label: 'Media Production',
    sort: '860',
  },
  {
    key: '17',
    label: 'Medical Devices',
    sort: '870',
  },
  {
    key: '13',
    label: 'Medical Practice',
    sort: '880',
  },
  {
    key: '139',
    label: 'Mental Health Care',
    sort: '890',
  },
  {
    key: '71',
    label: 'Military',
    sort: '900',
  },
  {
    key: '56',
    label: 'Mining & Metals',
    sort: '910',
  },
  {
    key: '35',
    label: 'Motion Pictures and Film',
    sort: '920',
  },
  {
    key: '37',
    label: 'Museums and Institutions',
    sort: '930',
  },
  {
    key: '115',
    label: 'Music',
    sort: '940',
  },
  {
    key: '114',
    label: 'Nanotechnology',
    sort: '950',
  },
  {
    key: '81',
    label: 'Newspapers',
    sort: '960',
  },
  {
    key: '100',
    label: 'Non-Profit Organization Management',
    sort: '970',
  },
  {
    key: '57',
    label: 'Oil & Energy',
    sort: '980',
  },
  {
    key: '113',
    label: 'Online Media',
    sort: '990',
  },
  {
    key: '123',
    label: 'Outsourcing/Offshoring',
    sort: '1000',
  },
  {
    key: '87',
    label: 'Package/Freight Delivery',
    sort: '1010',
  },
  {
    key: '146',
    label: 'Packaging and Containers',
    sort: '1020',
  },
  {
    key: '61',
    label: 'Paper & Forest Products',
    sort: '1030',
  },
  {
    key: '39',
    label: 'Performing Arts',
    sort: '1040',
  },
  {
    key: '15',
    label: 'Pharmaceuticals',
    sort: '1050',
  },
  {
    key: '131',
    label: 'Philanthropy',
    sort: '1060',
  },
  {
    key: '136',
    label: 'Photography',
    sort: '1070',
  },
  {
    key: '117',
    label: 'Plastics',
    sort: '1080',
  },
  {
    key: '107',
    label: 'Political Organization',
    sort: '1090',
  },
  {
    key: '67',
    label: 'Primary/Secondary Education',
    sort: '1100',
  },
  {
    key: '83',
    label: 'Printing',
    sort: '1110',
  },
  {
    key: '105',
    label: 'Professional Training & Coaching',
    sort: '1120',
  },
  {
    key: '102',
    label: 'Program Development',
    sort: '1130',
  },
  {
    key: '79',
    label: 'Public Policy',
    sort: '1140',
  },
  {
    key: '98',
    label: 'Public Relations and Communications',
    sort: '1150',
  },
  {
    key: '78',
    label: 'Public Safety',
    sort: '1160',
  },
  {
    key: '82',
    label: 'Publishing',
    sort: '1170',
  },
  {
    key: '62',
    label: 'Railroad Manufacture',
    sort: '1180',
  },
  {
    key: '64',
    label: 'Ranching',
    sort: '1190',
  },
  {
    key: '44',
    label: 'Real Estate',
    sort: '1200',
  },
  {
    key: '40',
    label: 'Recreational Facilities and Services',
    sort: '1210',
  },
  {
    key: '89',
    label: 'Religious Institutions',
    sort: '1220',
  },
  {
    key: '144',
    label: 'Renewables & Environment',
    sort: '1230',
  },
  {
    key: '70',
    label: 'Research',
    sort: '1240',
  },
  {
    key: '32',
    label: 'Restaurants',
    sort: '1250',
  },
  {
    key: '27',
    label: 'Retail',
    sort: '1260',
  },
  {
    key: '121',
    label: 'Security and Investigations',
    sort: '1270',
  },
  {
    key: '7',
    label: 'Semiconductors',
    sort: '1280',
  },
  {
    key: '58',
    label: 'Shipbuilding',
    sort: '1290',
  },
  {
    key: '20',
    label: 'Sporting Goods',
    sort: '1300',
  },
  {
    key: '33',
    label: 'Sports',
    sort: '1310',
  },
  {
    key: '104',
    label: 'Staffing and Recruiting',
    sort: '1320',
  },
  {
    key: '22',
    label: 'Supermarkets',
    sort: '1330',
  },
  {
    key: '8',
    label: 'Telecommunications',
    sort: '1340',
  },
  {
    key: '60',
    label: 'Textiles',
    sort: '1350',
  },
  {
    key: '130',
    label: 'Think Tanks',
    sort: '1360',
  },
  {
    key: '21',
    label: 'Tobacco',
    sort: '1370',
  },
  {
    key: '108',
    label: 'Translation and Localization',
    sort: '1380',
  },
  {
    key: '92',
    label: 'Transportation/Trucking/Railroad',
    sort: '1390',
  },
  {
    key: '59',
    label: 'Utilities',
    sort: '1400',
  },
  {
    key: '106',
    label: 'Venture Capital & Private Equity',
    sort: '1410',
  },
  {
    key: '16',
    label: 'Veterinary',
    sort: '1420',
  },
  {
    key: '93',
    label: 'Warehousing',
    sort: '1430',
  },
  {
    key: '133',
    label: 'Wholesale',
    sort: '1440',
  },
  {
    key: '142',
    label: 'Wine and Spirits',
    sort: '1450',
  },
  {
    key: '119',
    label: 'Wireless',
    sort: '1460',
  },
  {
    key: '103',
    label: 'Writing and Editing',
    sort: '1470',
  },
])
